import { config } from "~/config";

export const getPublicAssetFilePath = (path: string) => {
  return `${config.files.prefixes.publicAssets}/${path}`;
};
